import { render } from "./ValidationTypeSelectorContainer.vue?vue&type=template&id=6b061d62"
import script from "./ValidationTypeSelectorContainer.vue?vue&type=script&lang=js"
export * from "./ValidationTypeSelectorContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__